import React, { useEffect, useState } from "react";
import Content from "../Components/Content";
import { Card, CircularProgress, Grid, ThemeProvider } from "@mui/material";
import FilterButtonComp from "../Components/FilterButtonComp";
import DataCards from "../AdvisorNewDashBoard/DataCards";
import BranchTaskTrackBarChart from "./BranchTaskTrackBarChart";
import DisplayCurrentDateTime from "../Components/DisplayCurrentDateTime";
import UpcommingEvents from "../Components/UpcommingEvents";
import { useGetTokenOrLogout } from "../../../utils/token";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import LeadSourcePichartData from "./LeadSourcePichartData";
import NewCardcomp from "../../../components/card/NewCardcomp";
import CustomPopup from "../../../components/CustomPopup";
import LeadAssignConverted from "../../../newTestPrep/pages/AdvisorTaskWiseReport/LeadAssignConverted";
import TaskDetails from "../../../newTestPrep/pages/AdvisorTaskWiseReport/TaskDetails";
import NewEnquiryComp from "../popupComponent/NewEnquiryComp";
import TaskCompletedComp from "../popupComponent/TaskCompletedComp";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function DataEntryNewDashBoard() {
  const [selectedFilter, setSelectedFilter] = useState("currentmonth");

  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate=useNavigate()
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [cardsData, setCardsData] = useState([]);
  const [cardLoading, setCardLoading] = useState(false);
  const [taskBreakdownData, setdaskBreakDownData] = useState([]);
  const [taskLoading, setTaskLoading] = useState(false);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleClickFilter = (criteria, cardFilter) => {
    setSelectedFilter(criteria);

    if (criteria !== "custom") {
      handleFetchcardData(criteria, null, null);
      handletaskBreakdownData(criteria, null, null);
      setFromDate(null);
      setToDate(null);
    }
    if (criteria === "custom" && fromDate !== null && toDate !== null) {
      handleFetchcardData(criteria, fromDate, toDate);
      handletaskBreakdownData(criteria, fromDate, toDate);
    }
  };

  // Fetch Card Data
  const handleFetchcardData = async (criteria, fromDate, toDate) => {
    setCardLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),

      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}auditdashboard/chip-data`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        setCardsData(result);

        setCardLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
     
        navigate("/page500");
      }
    } catch (error) {
   
      navigate("/page500");
    }
  };

  // Fetch Bar chart data
  const handletaskBreakdownData = async (criteria, fromDate, toDate) => {
    setTaskLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),

      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}auditdashboard/task-breakdown`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setdaskBreakDownData(result);

        setTaskLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
     
        navigate("/page500");
      }
    } catch (error) {
   
      navigate("/page500");
    }
  };

  useEffect(() => {
    if (selectedFilter !== "custom") {
      handleFetchcardData(selectedFilter);
      handletaskBreakdownData(selectedFilter);
    }
  }, []);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    console.log("clicked");
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedFilter,
      to_date: toDate,
      from_date: fromDate,
      filter_type: cardFilter,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}auditdashboard/fetch-detailed-chip-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar("Bad Request", "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");
        setDetailsLoading(false);
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };
  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Grid container spacing={3}>
        {/* Left Side */}
        <Grid item xs={12} lg={9} sm={12} md={9}>
          <Grid container spacing={2}>
            {/* content */}
            <Grid item xs={12}>
              <Content />
            </Grid>

            {/* Filter Button */}
            <Grid item xs={12} sm={12} mt={2}>
              <FilterButtonComp
                selectedFilter={selectedFilter}
                handleClickFilter={handleClickFilter}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
              />
            </Grid>

            {/* Data Cards */}

            <Grid item xs={12} container spacing={2} gap={1}>
              <Grid item xs={12} sm={3.8} lg={2.9}>
                <DataCards
                  backGround="#D5F6E1"
                  title="New Enquiries"
                  iconSrc="/Group 1000002878.png"
                  value={
                    cardLoading ? (
                      <CircularProgress />
                    ) : (
                      cardsData?.new_enquiry || 0
                    )
                  }
                  onClick={() => getCardMoreInfo("New Enquiry", "new_enquiry")}
                />
              </Grid>

              <Grid item xs={12} sm={3.8} lg={2.9}>
                <DataCards
                  backGround="#E7F3FF"
                  title="Not Attempted"
                  iconSrc="/Group 1000002854.png"
                  value={
                    cardLoading ? (
                      <CircularProgress />
                    ) : (
                      cardsData?.not_connected_enquiry || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Not Attempted", "not_attempted")
                  }
                />
              </Grid>

              <Grid item xs={12} sm={3.8} lg={2.9}>
                <DataCards
                  backGround="#FFEDFB"
                  title="Tasks Assigned"
                  iconSrc="/Group 1000002879.png"
                  value={
                    cardLoading ? (
                      <CircularProgress />
                    ) : (
                      cardsData?.assigned_task || 0
                    )
                  }
                  onClick={() => getCardMoreInfo("Task Assign", "task_assign")}
                />
              </Grid>

              <Grid item xs={12} sm={3.8} lg={2.9}>
                <DataCards
                  backGround="#FFF6E2"
                  title="Tasks Completed"
                  iconSrc="/Group 1000002880.png"
                  value={
                    cardLoading ? (
                      <CircularProgress />
                    ) : (
                      cardsData?.completed_task || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Task  Completed", "task_completed")
                  }
                />
              </Grid>
            </Grid>

            {/* Branch Task BarChart */}

            <Grid item xs={12}>
              <NewCardcomp height="440px">
                <BranchTaskTrackBarChart
                  taskLoading={taskLoading}
                  taskData={taskBreakdownData}
                />
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Section */}

        <Grid item xs={12} lg={3} sm={12} md={3}>
          {/* Dispay Day And  Time */}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DisplayCurrentDateTime />
            </Grid>

            {/* Display Running And upcomming event */}
            <Grid item xs={12}>
              <UpcommingEvents />
            </Grid>

            <Grid item xs={12}>
              <NewCardcomp height="300px">
                <LeadSourcePichartData />
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          selectedcardFilter === "new_enquiry" ||
          selectedcardFilter === "not_attempted" ? (
            <NewEnquiryComp
              onClose={handleCloseDetailPopup}
              // selectedYear={selectedYear?.year}
              // monthName={monthname}
              SelectedData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
          ) : selectedcardFilter === "task_assign" ? (
            <TaskDetails
              onClose={handleCloseDetailPopup}
              // selectedYear={selectedYear?.year}
              // monthName={monthname}
              SelectedData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
          ) : (
            <TaskCompletedComp
              onClose={handleCloseDetailPopup}
              // selectedYear={selectedYear?.year}
              // monthName={monthname}
              SelectedData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
          )
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />
      
            <CustomSnackbar
              open={snackbarOpen}
              onClose={() => setSnackbarOpen(false)}
              message={snackbarMessage}
              severity={snackbarSeverity}
            />
    </>
  );
}
